<template>
    <keep-alive :include="includeList">
      <router-view></router-view>
    </keep-alive>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'views',
  data() {
    return {};
  },
  computed: {
    ...mapState({
      includeList: state => state.vm.includeList
    })
  },
  methods: {}
};
</script>
